import { use_slice_ui } from '@/hooks/store/use_slices';
import { HOOK__image_drag } from '@/pages/page_generation/_hooks/HOOK__image_drag';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { CONTEXT_MENU__image } from '../../image/CONTEXT_MENU__image';
import { DRAG_AND_DROP__image_compare__external } from '../ui/DRAG_AND_DROP__image_compare__external';
import { DRAG_AND_DROP__image_compare__internal } from '../ui/DRAG_AND_DROP__image_compare__internal';
import { IMAGE_COMPARE__image_a__upload } from './IMAGE_COMPARE__image_a__upload';

export function IMAGE_COMPARE__image_a() {
  const { grid2d_image_compare__image_a } = use_slice_ui(['grid2d_image_compare__image_a']);

  const { onDragStart, onDragEnd } = HOOK__image_drag(grid2d_image_compare__image_a);

  function render_view() {
    if (grid2d_image_compare__image_a.is_stub()) return <IMAGE_COMPARE__image_a__upload />;

    let image_asset = grid2d_image_compare__image_a;

    const url_absolute = path_relative_to_absolute(image_asset.url_relative_latest);

    return (
      <CONTEXT_MENU__image {...{ image_asset }}>
        <img
          {...{ onDragStart, onDragEnd }}
          src={url_absolute}
          alt={`${image_asset.image_size.width}x${image_asset.image_size.height}`}
          role="button"
          draggable={true}
          className={`rounded
            ${grid2d_image_compare__image_a.image_size.class_name_fit_view()}
              border border-2 border-component-border
              cursor-grab
              `}
        />
      </CONTEXT_MENU__image>
    );
  }

  return (
    <div className="relative h-32 w-full flex items-center justify-center">
      {render_view()}
      <DRAG_AND_DROP__image_compare__external />
      <DRAG_AND_DROP__image_compare__internal />
    </div>
  );
}
